export default __webpack_public_path__ + "static/media/DIY04.02feb6b8.JPG";